/** Lets anchored overlays (popovers) temporarily restore app scroll when a page locks `[data-scroll-container]`. */
type SuspendScrollLock = () => () => void;

let suspendScrollLock: SuspendScrollLock | null = null;

export function registerScrollContainerLockSuspend(impl: SuspendScrollLock | null) {
  suspendScrollLock = impl;
}

export function suspendScrollContainerLock(): () => void {
  return suspendScrollLock?.() ?? (() => {});
}
